import { render } from "./RankTabComponent.vue?vue&type=template&id=53ac24eb"
import script from "./RankTabComponent.vue?vue&type=script&lang=js"
export * from "./RankTabComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__